import React, { useEffect, useState } from 'react'

export default function Header() {
  const text = "GitPeek"
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const [showCursor, setShowCursor] = useState(false)

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[index])
        setIndex(prev => prev + 1)
      }, 120)

      return () => clearTimeout(timeout)
    } else {
      setShowCursor(true)
    }
  }, [index, text])

  return (
    <div className='header'>
      <header>
        <div className='title'>
          <h1>
            {displayedText}
            {showCursor && <span className="cursor">_</span>}
          </h1>
        </div>
      </header>
    </div>
  )
}